import { Institution } from '../../../types/Institution';

export type InstitutionTypeFilter = 'university' | 'languages' | 'schools' | 'all';

const fetchInstitutions = async (type: InstitutionTypeFilter): Promise<Institution[]> => {
  const typeQuery = type !== 'all' ? type : undefined;
  const institutionsUrl = `${process.env.REACT_APP_ESTUDI_API_URL}/estudi/web/institutions${
    typeQuery ? `?type=${typeQuery}` : ''
  }`;

  try {
    const response = await fetch(institutionsUrl);

    if (!response.ok) {
      throw new Error(`GET ${institutionsUrl} respondió ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(error);

    return Promise.reject(error);
  }
};

export const institutionsQueryFunction = (type: InstitutionTypeFilter = 'university') => ({
  queryKey: ['institutions', type],
  queryFn: async (): Promise<Institution[]> => fetchInstitutions(type)
});
